"use client";

import { useTransition } from "react";
import { useRouter } from "next/navigation";
import { revokeWhitelistRecipientAction } from "@/app/actions";

export default function RevokeButton({ customerId, recipientId }: { customerId: string; recipientId: string }) {
  const router = useRouter();
  const [pending, start] = useTransition();
  return (
    <button
      className="btn btn-ghost !px-4 !py-1.5 text-[13px]"
      disabled={pending}
      onClick={() =>
        start(async () => {
          await revokeWhitelistRecipientAction(customerId, recipientId);
          router.refresh();
        })
      }
    >
      Revoke
    </button>
  );
}
